module.exports = __webpack_public_path__ + "img/the witch summit.bbaf71be.png";